import React, {Fragment, useState, useEffect, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import TransportDeleteForm from "./TransportDeleteForm";
import TransportUpdateForm from "./TransportUpdateForm";
import TransportCreateForm from "./TransportCreateForm";
import TransportItem from "./TransportItem";
import {getTransports} from "../../actions/transport";
import SearchForm from "../layout/SearchForm";
import {Plus} from "react-feather";
import TableSpinner from "../layout/TableSpinner";
import CustomPaginationWithManyPages from "../layout/CustomPaginationWithManyPages";
import { usePermission } from '../../hooks/usePermission';
import useActiveFirm from '../../hooks/useActiveFirm';
import {getParams} from "../../utils/hooks/getParams";

const Transports = () => {
    const { userCan } = usePermission();
    const dispatch = useDispatch();
    const { firmId, firmName } = useActiveFirm();
    const {transports, loading, numberOfPages, currentPage, total_transports} = useSelector(state => state.transport);
    const [show, setShow] = useState(false);

    // Wrapper function to ensure firm_id is always included when calling getTransports
    const getTransportsWithFirm = useCallback((page, params = {}) => {
        const filters = { ...params };
        if (firmId) {
            filters.firm_id = firmId;
        }
        // Clean up undefined/null values
        Object.keys(filters).forEach(key => {
            if (filters[key] === undefined || filters[key] === null || filters[key] === '' || filters[key] === 'undefined' || filters[key] === 'null') {
                delete filters[key];
            }
        });
        return getTransports(page, filters);
    }, [firmId]);

    // Fetch data when firm changes
    useEffect(() => {
        if (firmId) {
            const urlParams = getParams();
            // Get current page from URL or default to 1
            const currentPage = parseInt(urlParams.page) || 1;
            dispatch(getTransportsWithFirm(currentPage, urlParams));
        }
    }, [dispatch, firmId, getTransportsWithFirm]);

    if (!userCan('view transports')) {
        return <div>You don't have permission to view transports.</div>;
    }

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <Fragment>
            <div className="container-fluid p-0">
                <div className="row mb-2">
                    <div className="col-md-12 col-lg-8">
                        <h1 className="h3 mb-3">
                            <strong>Transportlar</strong> ({total_transports})
                            {firmName && <span className="text-muted ms-2" style={{fontSize: '14px', fontWeight: 'normal'}}>— {firmName}</span>}
                        </h1>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <SearchForm getPageItems={getTransportsWithFirm}/>
                    </div>

                    <div className="col-md-6">
                        <div className="crud_actions text-end">
                            {userCan('create transports') && (
                                <button className="btn btn-primary" onClick={handleShow}>
                                    Transport <Plus/>
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-xl-12 col-xxl-12 d-flex">
                        <div className="card w-100 table-responsive">
                            {loading && <TableSpinner/>}
                            <table className="table custom-table table-hover">
                                <thead className="table-light">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Nomi</th>
                                    <th scope="col">Transport raqami</th>
                                    <th scope="col">Haydovchi</th>
                                    <th scope="col">Amallar</th>
                                </tr>
                                </thead>
                                <tbody>
                                {transports.map((item, index) => (
                                    <TransportItem 
                                        key={item.id} 
                                        number={index + 1} 
                                        transport={item}
                                    />
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-12 col-xxl-12 d-flex">
                            <CustomPaginationWithManyPages
                                numberOfPages={numberOfPages}
                                getPageItems={getTransportsWithFirm}
                                current_page={currentPage}
                            />
                        </div>
                </div>
            </div>

            {userCan('create transports') && (
                <TransportCreateForm 
                    show={show} 
                    handleClose={handleClose}
                />
            )}

            {userCan('edit transports') && (
                <TransportUpdateForm/>
            )}

            {userCan('delete transports') && (
                <TransportDeleteForm/>
            )}
        </Fragment>
    );
};

export default Transports;
